import React from "react";

import DashboardIcon from "./../../images/icons/navigation/analisis.svg";
import EpIcon from "./../../images/icons/barra-dash/street-food.svg";

import ButtonNav from "./../../miscellaneous/container/ButtonNav";

// import * as NavigationIcons from "./../../images/icons/navigation/StringsIcons";

import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";

import "./home.css";

function HomeComponent(props) {
  return (
    <>
      <div className="background-body">
        <div className="content-landing">
          <div className="center-content" style={{flexWrap:'wrap'}}>
            <ButtonNav
              src={DashboardIcon}
              text={LANDING_MENU_BAR.DASHBOARD}
              onClick={() => props.onChangeRoute("/Dashboard")}
              className="button button--antiman button--text-thick button--text-upper button--size-m button--inverted-alt button--round-s button--border-thick"
            />
            {/* <ButtonNav
              src={GisIcon}
              text={LANDING_MENU_BAR.COMMUNAL_FILE}
              onClick={() => props.onChangeRoute("/Ficha-municipal")}
              className="button button--antiman button--text-thick button--text-upper button--size-m button--inverted-alt button--round-s button--border-thick"
            /> 
            {
              (props.session.user.permitions.map(p => p.rol).includes('ADMIN') ||
                props.session.user.permitions.map(p => p.rol).includes('GOBIERNO')) &&
              <>
                <ButtonNav
                  src={CreadorIcon}
                  text={LANDING_MENU_BAR.CREATE_INFORMS}
                  onClick={() => props.onChangeRoute("/Crear-informe")}
                  className="button button--antiman button--text-thick button--text-upper button--size-m button--inverted-alt button--round-s button--border-thick"
                />
                <ButtonNav
                  src={GeneradorIcon}
                  text={LANDING_MENU_BAR.INFOMR_WEEKLY}
                  onClick={() => props.onChangeRoute("/informe-semanal")}
                  className="button button--antiman button--text-thick button--text-upper button--size-m button--inverted-alt button--round-s button--border-thick"
                />
              </>
            }
            */}
            {
              (props.session.user.permitions.map(p => p.rol).includes('EP')) &&
              <>
                <ButtonNav
                  src={EpIcon}
                  text={LANDING_MENU_BAR.EP}
                  onClick={() => props.onChangeRoute("/ep")}
                  className="button button--antiman button--text-thick button--text-upper button--size-m button--inverted-alt button--round-s button--border-thick"
                />
              </>
            }

          </div>
        </div>
      </div>
    </>
  );
}

export default HomeComponent;
